import script from "./Comments.vue?vue&type=script&setup=true&lang=js"
export * from "./Comments.vue?vue&type=script&setup=true&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=7a319718&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a319718"]])

export default __exports__